import { useTranslations } from '~src/commons/utils/translations/translate';
import { Colors, colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

type DisclaimerMessageProps = {
  message?: string;
  color?: keyof Colors;
};

export const DisclaimerMessage = ({
  message,
  color = 'superlightOrange',
}: DisclaimerMessageProps) => {
  const { tICU } = useTranslations();

  if (!message) {
    return null;
  }

  return <div css={styles.promptMessage(color)}>{tICU(`widget.${message}`)}</div>;
};

const styles = {
  promptMessage: (color: keyof Colors) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    marginBottom: '16px',
    marginTop: '16px',
    fontVariationSettings: '"wght" 400',
    ...fontStyles.px14_20,
    backgroundColor: colors[color],
  }),
};
